<div class="modal-content mymodal">
    <div class="modal-header">
        <h2 class="modal-title">{{serverName}} details</h2>
    </div>
    <div class="modal-body px-5">

        <div class="row">
            <div class="col-6 br-1">
                <div *ngFor="let item of environment | slice:0:(environment.length + 1) / 2" class="row mb-2">
                    <div>
                        <div class="col-12">
                            <b>{{ item.key }}</b>
                        </div>
                        <div class="col-12">
                            <p>{{ item.value }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="d-flex align-items-center justify-content-center col-1">
                <div class="vr" style="height: 100%;"></div>
            </div> -->
            <div class="col-6">
                <div *ngFor="let item of environment | slice:(environment.length + 1) / 2" class="row mb-2">
                    <div>
                        <div class="col-12">
                            <b>{{ item.key }}</b>
                        </div>
                        <div class="col-12">
                            <p>{{ item.value }}</p>
                        </div>
                    </div>           
                </div>
            </div>
        </div>

    </div>
    <div class="modal-footer d-flex justify-content-end">
        <button type="button" class="btn btn-outline-primary" (click)="activeModal.close('Close click')">Close</button>
    </div>
</div>